<template>
    <div>
        <div class="box">
            <div class="box-inner product-box listing">
                <div class="row">
                    <div class="col-sm-5 product-col">
                        <a :href="url" class="product-img">
                            <slot name="thumbnail"></slot>
                        </a>
                    </div>
                    <div class="col-sm-7 product-col">
                        <div class="product-details">
                            <a :href="url" class="product-title">
                                <slot name="title"></slot>
                            </a>

                            <stock-level :stock="stock" :backorder="backorder" :incoming="incoming" :deliverydays="deliverydays"></stock-level> <span class="sku">SKU Number: <slot name="sku"></slot></span>

                            <slot name="description"></slot>

                            <template v-if="!tiers || !tiers.length">
                                <div class="product-qty-price">
                                    <div class="product-price">
                                        <p class="price-per" v-if="variant.unit_qty > 1">Price per 100 units</p>
                                        <p class="price-per" v-else>Price per unit</p>
                                        <product-price :price="variant.unit_price" :tax="variant.unit_tax ? variant.unit_tax : variant.tax"></product-price>
                                    </div>
                                </div>
                            </template>
                            <template v-else>
                                <pricing-table :per-unit="variant.unit_qty" :price="variant.price ? variant.price : variant.unit_price" :tax="variant.factor_tax ? variant.factor_tax : (variant.unit_tax || variant.unit_tax == 0 ? variant.unit_tax : variant.tax)" :tiers="tiers"></pricing-table>
                            </template>
                        </div> <!-- product-details -->
                        <div class="row">
                            <div class="col-md-4">
                                <input type="number" max="5000" class="form-control" v-model="quantity" value="1" @click="nullQuantityIfOne" @blur="resetQuantity">
                            </div>
                            <div class="col-md-8">
                                <add-to-basket
                                    :stock="stock"
                                    :incoming="incoming"
                                    :backorder="backorder"
                                    :name="name"
                                    :id="variant.id"
                                    :quantity="quantity"
                                    :shipping="shipping"
                                    @success="quantity = 1"
                                >
                                    Add to Basket
                                </add-to-basket>
                            </div>
                        </div>
                    </div> <!-- product-col -->

                </div> <!-- row -->

            </div> <!-- product-box -->
        </div>
    </div>
</template>

<script>
    import AddToBasket from '../Basket/AddToBasket.vue';
    import StockLevel from '../Product/StockLevel.vue';
    import PricingTable from '../Elements/PricingTable.vue';
    import ProductPrice from '../Product/ProductPrice.vue';

    export default {
        components: {
            AddToBasket,
            PricingTable,
            StockLevel,
            ProductPrice
        },
        props: {
            shipping: {
                type: String,
                default: null
            },
            name: {
                type: String,
                default: null
            },
            stock: {
                type: [String, Number],
                default: 0
            },
            url: {
                type: String
            },
            variant: {
                type: Object
            },
            backorder: {
                type: String,
                default: 'always'
            },
            incoming: {
                type: Number,
                default: 1
            },
            deliverydays: {
                type: [String, Number],
                default: 0
            }
        },
        data() {
            return {
                quantity: 1,
                tier: null,
                loaded: false
            }
        },
        mounted() {
            this.loaded = true;
        },
        computed: {
            tiers() {
                return this.variant.tiers;
            }
        },
        methods: {
            nullQuantityIfOne () {
                if (this.quantity == 1 || !this.quantity) {
                    this.quantity = null;
                }
            },
            resetQuantity () {
                if (!this.quantity) {
                    this.quantity = 1;
                }
            }
        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/Components/Search/SearchResultCard.vue